/**
 * Homepage CTA Block Template
 * By Prashant Bhatt <pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders CTA Block
 *  might have to move to organism
 */

import React, { useEffect, useState } from 'react';
import Loading from "@svb/api-loading-component/dist/components/index";
// import { Utils } from '@svb/api-content-component';
import { getFileContent } from '../../helpers/utilityFunctions';
import { browseAPIhandler } from '../../helpers/browseAPIhandler';
import { SVBCTABlock } from '@svb/portal-ui-react-components';

/**
  * HomepageCTA
  * @param content: url of the Banner notification content
  * @param backgroundImg: url for the backgrond image for this section
  * @returns HomepageCTA block 
*/

const HomepageCTA = ({ datatestid, testMockContent, content }) => {
    const [loading, setLoading] = useState(true);
    const { regenTokenandBrowse } = browseAPIhandler();
    const getCTAContent = datatestid ? testMockContent : getFileContent(`${content}`, regenTokenandBrowse);
    useEffect(() => {
        if (getCTAContent.type === 'success') {
            setLoading(false)
        }
    }, [getCTAContent.response])

    if (loading) {
        return <Loading />
    }
const ctaData = getCTAContent.response;
    return (
        <section id="homepage-ctablock" className="ctablock-section" data-testid={datatestid} >
           <div className="container svb-container-fixed col-md-9 col-sm-12" data-testid="homepage-cta">
           <SVBCTABlock
           title={ctaData.title}
            content={ctaData.content}
            primaryButton={ctaData.primaryButton}
            primaryUrl={ctaData.primaryUrl}
            secondaryButton={ctaData.secondaryButton}
            secondaryUrl={ctaData.secondaryUrl}
            extraClasses={ctaData.extraClasses}
            color="none"
            />
           </div>
            
        </section>

    );
}
export default HomepageCTA;